import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { useNavigate } from "react-router-dom";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader, Chip } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import UserDetailsContext from "../../context/auth";
import { getAllShiftPaisaConfigurations } from "./Component/api";

const ShiftPaisaConfiguration = () => {
  const navigate = useNavigate();
  const { user, AccessData } = useContext(UserDetailsContext);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [configList, setConfigList] = useState([]);

  useEffect(() => {
    fetchConfigs();
  }, []);

  const columns = [
    {
      field: "name",
      headerName: "Configuration Name",
      flex: 1.5,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "employeeType",
      headerName: "Employee Type",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => params.value || "All",
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => params.value || "All",
    },
    {
      field: "minOtHours",
      headerName: "Min OT (hrs)",
      flex: 0.8,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "mustNotBeLate",
      headerName: "Must Not Be Late",
      flex: 0.8,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Yes" : "No"}
          color={params.value ? "warning" : "default"}
          size="small"
          variant="outlined"
        />
      ),
    },
    {
      field: "isActive",
      headerName: "Status",
      flex: 0.7,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
      renderCell: (params) => (
        <Chip
          label={params.value ? "Active" : "Inactive"}
          color={params.value ? "success" : "default"}
          size="small"
          variant="outlined"
        />
      ),
    },
  ];

  const rows = (configList || []).map((c) => ({
    id: c.id,
    name: c.name,
    employeeType: c.employeeType,
    category: c.category,
    minOtHours: ((c.minOtBeyondShiftMinutes || 0) / 60).toFixed(1),
    mustNotBeLate: c.mustNotBeLate,
    isActive: c.isActive,
  }));

  const handleNewConfig = () => {
    navigate("/shift-paisa-configuration/add");
  };

  const onRowClick = (e) => {
    if (e?.id) {
      navigate(`/shift-paisa-configuration/add?id=${e.id}`);
    }
  };

  const fetchConfigs = async () => {
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        { query: getAllShiftPaisaConfigurations },
        { headers: { "Content-Type": "application/json" } }
      );
      const data = response.data.data.allShiftPaisaConfigurations;
      setConfigList(data);
      setPageState({ ...pageState, loading: false, state: "success" });
    } catch (error) {
      console.error("Error fetching shift paisa configs:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Shift Paisa Configuration
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  Configure shift paisa eligibility rules for payroll
                </MaterialTypography>
              </Stack>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={handleNewConfig}
              >
                Add Configuration
              </MaterialButton>
            </Stack>
          }
        />
        <MaterialDataGrid
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onRowClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No shift paisa configurations found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  Click "Add Configuration" to create a shift paisa rule.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default ShiftPaisaConfiguration;
